import React, { useState } from 'react';
import './Item.scss';
import { format } from 'date-fns';
import Lightbox from 'react-image-lightbox';

export default ({ item }) => {
  const [open, setOpen] = useState(false);

  const [onLoaded, setOnLoaded] = useState(false);

  return (
    <div className="item">
      <div
        onClick={() => setOpen(true)}
        className={`item__image-wrapper ${!onLoaded ? 'item__image-wrapper--loading' : ''}`}
      >
        <img 
          onLoad={() => setOnLoaded(true)}
          className={`item__image ${onLoaded ? 'item__image--loaded' : ''}`}
          src={item.img_src_t} 
          alt={`${item.camera_name_t} ${item.rover_name_t}`} />
      </div>


      {open && (
        <Lightbox
          mainSrc={item.img_src_t}
          onCloseRequest={() => setOpen(false)}
        />
      )}
      <div className="item__content">
        <div className="item__content__line">
          <div className="item__content__line__item">
            <b>Sol:</b> {item.sol_i}
          </div>
          <div className="item__content__line__item">
            <b>Date:</b> {format(new Date(item.earth_date_dt), 'dd.MM.yyyy')}
          </div>
        </div>
        <div className="item__content__line">
          <div className="item__content__line__item">
            <b>Camera:</b> {item.camera_name_t} ({item.camera_short_t})
          </div>
        </div>
        <div className="item__content__line">
          <div className="item__content__line__item">
            <b>Informations about the rover:</b>
          </div>
        </div>
        <div className="item__content__line item__content__line--small">
          <div className="item__content__line__item">
            <b>Name:</b> {item.rover_name_t}
          </div>
          <div className="item__content__line__item">
            <b>Launchdate:</b> {format(new Date(item.rover_launch_dt), 'dd.MM.yyyy')}
          </div>
        </div>
      </div>
    </div>
  )
}